module.exports = __webpack_public_path__ + "static/media/6COPUOS1.c1f9cef8.jpg";